import t from 'react-translate';
import { css } from '@emotion/react';
import React from 'react';
import { primary } from 'styles/global_defaults/colors';
import ExpertMentoringGuides from './expert-mentoring-guides';
import ActionItemsInfo from './action-items-info';
import { PROGRAM_CONFIGURATION_SECTION_WIDTH } from '../../constants';

const styles = css`
  max-width: ${PROGRAM_CONFIGURATION_SECTION_WIDTH}px;

  a {
    color: ${primary};
  }
`;

const Guidance = () => (
  <div css={styles} className='mx-auto'>
    <div className='title heading-2 mb-2'>
      {t.MENTORING_PROGRAMS.SETTINGS.TABS.GUIDANCE.TITLE()}
    </div>
    <div className='text-body black mb-6'>
      {t.MENTORING_PROGRAMS.SETTINGS.TABS.GUIDANCE.DESCRIPTION()}
    </div>
    <ExpertMentoringGuides />
    <ActionItemsInfo />
  </div>
);

export default Guidance;
